import { useState } from 'react';
import { beginFoodFlow, captureFoodOrigin } from '../lib/food-origin';
import { useLocation, useNavigate } from 'react-router-dom';
import { MEAL_TITLE, formatFullDate, type Meal } from '@jungles/shared';
import { haptic } from '../lib/telegram';
import { Sheet } from './Sheet';
import { BarcodeIcon, SearchIcon } from './icons';

/**
 * H6 · «Добавить питание» и N4 · «Добавить в приём пищи».
 * Одна шторка: на Главной без приёма, в дневнике — с приёмом и датой.
 */
export function FoodPicker({
  meal,
  date,
  onClose,
}: {
  meal: Meal;
  date: string;
  onClose: () => void;
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const [origin] = useState(() => captureFoodOrigin(location));
  const params = `meal=${meal}&date=${date}`;

  const go = (path: string) => {
    haptic();
    beginFoodFlow(origin);
    onClose();
    navigate(path, { state: { foodOrigin: origin, ...(path.startsWith('/nutrition/search') ? {foodBackground:location} : {}) } });
  };

  return (
    <Sheet
      title={`Добавить в «${MEAL_TITLE[meal]}»`}
      subtitle={formatFullDate(date)}
      onClose={onClose}
    >
      <button className="srch" type="button" onClick={() => go(`/nutrition/search?${params}`)}>
        <SearchIcon />
        Найти продукт или блюдо
      </button>

      <p className="nt" style={{ margin: '14px 0 0' }}>
        Или добавьте по-другому
      </p>

      <button className="opt pr" type="button" onClick={() => go(`/nutrition/food?${params}`)}>
        <b>Вручную</b>
        <span>Название, граммы и КБЖУ</span>
        <img src="/assets/ui/tab-food.webp" alt="" />
      </button>

      <button className="opt" type="button" onClick={() => go(`/nutrition/scan?${params}`)}>
        <b>Сканировать</b>
        <span>Штрихкод или фото этикетки</span>
        <span className="ic" aria-hidden="true">
          <BarcodeIcon size={30} />
        </span>
      </button>

      <button className="b ghost" type="button" onClick={onClose} style={{ marginTop: 8 }}>
        Отмена
      </button>
    </Sheet>
  );
}
